import { Button, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import React from "react";
import { Time } from "../../Helper/Time";
import { WeekLongString, WeekType } from "../../Helper/Week";
import { WeekConditionsType } from "../../Helper/WeekConditions";
import { WorkPattern } from "../../Objects/WorkPattern";
import StoreWorkingTimeEditDialog from "../organisms/StoreWorkingTimeEditDialog";

export interface StoreWorkingTimeTableProps {
    wrkptnset_id: number
    workingTimeList: WorkPattern[]
    requestReloadWorkPattern: () => void
}

interface TableData1 {
    week: string
    start?: Time
    end?: Time
    index?: number
    weekType?: WeekConditionsType
}

const StoreWorkingTimeTable: React.FC<StoreWorkingTimeTableProps> = ({
    wrkptnset_id,
    workingTimeList,
    requestReloadWorkPattern
}) => {
    const [tableDatas1, setTableDatas1] = React.useState<TableData1[]>([])
    const [holWorkingTimeData, setHolWorkingTimeData] = React.useState<WorkPattern>()
    const [preoffWorkingTimeData, setPreoffWorkingTimeData] = React.useState<WorkPattern>()

    const [editWorkPattern, setEditWorkPattern] = React.useState<WorkPattern>()

    React.useEffect(() => {
        let data1: TableData1[] = [];
        ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].forEach(w => {
            let workingTimeIndex = workingTimeList.findIndex(value => value.week_conditions === w)
            if (workingTimeIndex >= 0) {
                let workingTime = workingTimeList[workingTimeIndex]
                data1.push({
                    week: WeekLongString[w as WeekType],
                    start: workingTime?.wrkptn_open,
                    end: workingTime?.wrkptn_close,
                    index: workingTimeIndex,
                    weekType: w as WeekConditionsType,
                })
            } else {
                data1.push({
                    week: WeekLongString[w as WeekType],
                    weekType: w as WeekConditionsType,
                })
            }
        })
        setTableDatas1(data1)

        let holWorkingTimeIndex = workingTimeList.findIndex(value => value.week_conditions === 'hol')
        if (holWorkingTimeIndex >= 0) {
            setHolWorkingTimeData( workingTimeList[holWorkingTimeIndex] )
        } else {
            setHolWorkingTimeData( undefined )
        }
        let preoffWorkingTimeIndex = workingTimeList.findIndex(value => value.week_conditions === 'preoff')
        if (preoffWorkingTimeIndex >= 0) {
            setPreoffWorkingTimeData( workingTimeList[preoffWorkingTimeIndex] )
        } else {
            setPreoffWorkingTimeData( undefined )
        }

    }, [workingTimeList])

    return (
        <Grid container spacing={2}>
            <Grid item
                xs={12}
                md={6}
            >
                <Typography variant="subtitle2">通常の各曜日の営業時間を設定します。</Typography>
                <Divider />
                <TableContainer
                    sx={{
                        px: 1
                    }}
                >
                    <Table>
                        <TableBody>
                            {tableDatas1.map((tableData, index) => (
                                <TableRow key={index}>
                                    <TableCell
                                        sx={{
                                            width: "30%"
                                        }}
                                        align="center"
                                    >{tableData.week}</TableCell>
                                    <TableCell
                                        align="center"
                                    >
                                        <Typography component="span" sx={{ mx: 1 }}>
                                            {tableData.start ? tableData.start.toStringHM() : "未設定"}
                                        </Typography>
                                        <Typography component="span" sx={{ mx: 1 }}>～</Typography>
                                        <Typography component="span" sx={{ mx: 1 }}>
                                            {tableData.end ? tableData.end.toStringHM() : "未設定"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={() => {
                                                if (tableData.index !== undefined && workingTimeList[tableData.index]) {
                                                    setEditWorkPattern(workingTimeList[tableData.index])
                                                } else if (tableData.weekType) {
                                                    setEditWorkPattern({
                                                        week_conditions: tableData.weekType
                                                    })
                                                }
                                            }}
                                        >編集</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item
                xs={12}
                md={6}
            >
                <Typography variant="subtitle2">祝日など特殊な日程を設定します。変更がある箇所のみ設定してください。</Typography>
                <Divider />
                <TableContainer
                    sx={{
                        px: 1
                    }}
                >
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        width: "40%"
                                    }}
                                    align="center"
                                >祝日</TableCell>
                                <TableCell
                                    sx={{
                                        width: "20%"
                                    }}
                                    align="center"
                                >OPEN</TableCell>
                                <TableCell
                                    align="center"
                                >
                                    <Typography component="span">{holWorkingTimeData?.wrkptn_open ? holWorkingTimeData.wrkptn_open.toStringHM() : "未設定"}</Typography>
                                </TableCell>
                                <TableCell
                                    align="center"
                                    rowSpan={2}
                                >
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            if (holWorkingTimeData) {
                                                setEditWorkPattern(holWorkingTimeData)
                                            } else {
                                                setEditWorkPattern({
                                                    wrkptnset_id: wrkptnset_id,
                                                    week_conditions: WeekConditionsType.HOL
                                                })
                                            }
                                        }}
                                    >編集</Button>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        width: "40%"
                                    }}
                                    align="center"
                                ></TableCell>
                                <TableCell
                                    sx={{
                                        width: "20%"
                                    }}
                                    align="center"
                                >CLOSE</TableCell>
                                <TableCell
                                    align="center"
                                >
                                    <Typography component="span">{holWorkingTimeData?.wrkptn_close ? holWorkingTimeData.wrkptn_close.toStringHM() : "未設定"}</Typography>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        width: "40%"
                                    }}
                                    align="center"
                                >翌日が休日の日</TableCell>
                                <TableCell
                                    sx={{
                                        width: "20%"
                                    }}
                                    align="center"
                                >OPEN</TableCell>
                                <TableCell
                                    align="center"
                                >
                                    <Typography component="span">{preoffWorkingTimeData?.wrkptn_open ? preoffWorkingTimeData.wrkptn_open.toStringHM() : "未設定"}</Typography>
                                </TableCell>
                                <TableCell
                                    align="center"
                                    rowSpan={2}
                                >
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                            if (preoffWorkingTimeData) {
                                                setEditWorkPattern(preoffWorkingTimeData)
                                            } else {
                                                setEditWorkPattern({
                                                    wrkptnset_id: wrkptnset_id,
                                                    week_conditions: WeekConditionsType.PREOFF
                                                })
                                            }
                                        }}
                                    >編集</Button>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    sx={{
                                        width: "40%"
                                    }}
                                    align="center"
                                ></TableCell>
                                <TableCell
                                    sx={{
                                        width: "20%"
                                    }}
                                    align="center"
                                >CLOSE</TableCell>
                                <TableCell
                                    align="center"
                                >
                                    <Typography component="span">{preoffWorkingTimeData?.wrkptn_close ? preoffWorkingTimeData.wrkptn_close.toStringHM() : "未設定"}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <StoreWorkingTimeEditDialog
                workPattern={editWorkPattern}
                onClose={(isEdit) => {
                    if( isEdit ) {
                        requestReloadWorkPattern()
                    }
                    setEditWorkPattern(undefined)

                }}
            />
        </Grid>
    )
}

export default StoreWorkingTimeTable